
const digest = '361398507db2e3eb68af379afaf3f85b6198ce4605302195c431067d106f7e7b';
const classes = {"otherMonth":"_otherMonth_1dbjy_1"};
const css = `._otherMonth_1dbjy_1 {
  color: #da1010;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  